import React, { Component } from "react";
import axios from 'axios';
import { Button } from 'react-bootstrap';
import config from '../../config/core';


const FUSER_HOST = config[process.env.NODE_ENV].FUSER_HOST;
export default class BookingFeedback extends Component {

    constructor(props) {
        super();
        this.state = {
            id: props.id,
            stars: 0,
            feedback: "",
            submitDisabled: false,
            feedbackSubmitted: false
        };
    }

    componentDidMount() {
        const ratingDiv = document.getElementById("star-rating");
        const stars = ratingDiv.querySelectorAll(".star");
        stars.forEach(function (elem) {
            elem.addEventListener("mouseover", function (event) {
                const onStar = parseInt(elem.getAttribute("data-value"));
                stars.forEach(function (ele) {
                    if (parseInt(ele.getAttribute("data-value")) <= onStar) {
                        ele.classList.remove('not-rated');
                        ele.classList.add('rated');
                    } else {
                        ele.classList.remove('rated');
                        ele.classList.add('not-rated');
                    }
                });

            });
        });
    }

    handleFeedbackSubmit = async (event) => {
        this.setState({ submitDisabled: true });

        const feedback = document.getElementById("feedbackText").value;
        const starRating = document.querySelectorAll(".star.rated").length;

        try {
            await axios.post(`${FUSER_HOST}/api/v1/sal/bookingFeedback`, { Id: this.state.id, feedback, starRating });
        } catch (error) {

        }

        this.setState({ feedbackSubmitted: true });
    }

    render() {
        if (this.state.feedbackSubmitted) {
            return (
                <h1 id="thankyou">Thank you</h1>
            )
        } else {
            return (
                <div className="feedback">
                    Please rate us on the booking experience
                    <div id="star-rating">
                        <span>Rating:</span>
                        <span data-value="1" className="star not-rated">&#9733;</span>
                        <span data-value="2" className="star not-rated">&#9733;</span>
                        <span data-value="3" className="star not-rated">&#9733;</span>
                        <span data-value="4" className="star not-rated">&#9733;</span>
                        <span data-value="5" className="star not-rated">&#9733;</span>
                    </div>
                    <label>
                        Please provide your valuable feedback:
                        <textarea id="feedbackText" maxLength="300" rows="50" cols="50" wrap="hard" />
                    </label>

                    <div>
                        <Button variant="outline-primary" onClick={this.handleFeedbackSubmit} disabled={this.state.submitDisabled}>
                            Submit
                        </Button>
                    </div>

                    {/* <button id="feedbackSubmit" onClick={this.handleFeedbackSubmit}>Submit</button> */}
                </div>
            )
        }

    }
}
